import ApiService from './api'

const BASE_URL = '/hr/employees'

export const employeeService = {
  // Get all employees
  getAllEmployees: async () => {
    try {
      const response = await ApiService.get(BASE_URL)
      return response
    } catch (error) {
      console.error('Error fetching employees:', error)
      throw error
    }
  },

  // Create a new employee
  createEmployee: async (employeeData) => {
    try {
      const response = await ApiService.post(BASE_URL, employeeData)
      return response
    } catch (error) {
      console.error('Error creating employee:', error)
      throw error
    }
  },

  // Update an employee
  updateEmployee: async (employeeId, employeeData) => {
    try {
      const response = await ApiService.patch(`${BASE_URL}/${employeeId}`, employeeData)
      return response
    } catch (error) {
      console.error('Error updating employee:', error)
      throw error
    }
  },

  // Delete an employee
  deleteEmployee: async (employeeId) => {
    try {
      const response = await ApiService.delete(`${BASE_URL}/${employeeId}`)
      
      // Handle different possible success responses for DELETE requests
      if (response === '' || response === null || response === undefined) {
        return { success: true, message: 'Employee deleted successfully' }
      }
      
      return response
    } catch (error) {
      console.error('Error deleting employee:', error)
      
      // Check if it's actually a successful delete (204 No Content)
      if (error.response?.status === 204) {
        return { success: true, message: 'Employee deleted successfully' }
      }
      
      throw error
    }
  },

  // Get employee by ID
  getEmployeeById: async (employeeId) => {
    try {
      const response = await ApiService.get(`${BASE_URL}/${employeeId}`)
      return response
    } catch (error) {
      console.error('Error fetching employee:', error)
      throw error
    }
  }
}

export default employeeService
